import gql from 'graphql-tag';

export const SendPharmacyOnboardingInstructionsMutation = gql`
  mutation SendPharmacyOnboardingInstructions($data: SendPharmacyOnboardingInstructionsInput!) {
    sendPharmacyOnboardingInstructions(data: $data) {
      ncpdp
    }
  }
`;
